import React from 'react';
import { useForm } from 'react-hook-form';
import { TextField, Button, Typography, Container } from '@mui/material';
import { Creators as UserSessionCreators } from 'store/user-session/user-session-duck.js';
import * as S from './styled.js';
import loginBackgroundImage from 'assets/loginBackgroundImage.jpg';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const LoginPage = ({ userSessionLoginAsync }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {
    userSessionLoginAsync(values);
  };

  return (
    <S.LoginContainer>
      <S.ImageSection src={loginBackgroundImage} />
      <S.FormContainer>
        <Typography variant="h4" gutterBottom>
          Acesso Painel Administrativo
        </Typography>
        <Container component="form" onSubmit={handleSubmit(onSubmit)} disableGutters>
          <TextField
            label="Usuário"
            variant="filled"
            fullWidth
            margin="normal"
            autoComplete="off"
            error={!!errors.userName}
            helperText={errors.userName?.message}
            {...register('userName', {
              required: 'O nome de usuário é obrigatório',
            })}
            sx={{ backgroundColor: 'white' }}
          />
          <TextField
            label="Senha"
            type="password"
            variant="filled"
            fullWidth
            margin="normal"
            error={!!errors.password}
            helperText={errors.password?.message}
            {...register('password', {
              required: 'A senha é obrigatória',
            })}
            sx={{ backgroundColor: 'white' }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ mt: 5 }}
          >
            Entrar
          </Button>
        </Container>
      </S.FormContainer>
    </S.LoginContainer>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators(UserSessionCreators, dispatch);
LoginPage.propTypes = {
  userSessionLoginAsync: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(LoginPage);
